import { CanActivateFn } from '@angular/router';
import { PermissionsService } from '@core/permissions/services/permissions.service';
import { inject } from '@angular/core';

export const SettingsGuard: CanActivateFn = () => {
  const permissionsService: PermissionsService = inject(PermissionsService);
  return (
    permissionsService.hasAdministrationAccess() &&
    (permissionsService.canViewTelegramSettings() || permissionsService.canConfigureGroupSettings())
  );
};
